export const ADMIN_TENANT_MODES = ['none', 'domain', 'code'] as const

export type AdminTenantMode = typeof ADMIN_TENANT_MODES[number]

export const normalizeAdminTenantMode = (value: unknown): AdminTenantMode => {
  const mode = String(value ?? '').trim().toLowerCase()
  return ADMIN_TENANT_MODES.includes(mode as AdminTenantMode)
    ? mode as AdminTenantMode
    : 'code'
}

export const ADMIN_TENANT_MODE = normalizeAdminTenantMode(
  import.meta.env.VITE_APP_TENANT_MODE
)

export const isAdminTenantCodeMode = (
  mode: AdminTenantMode = ADMIN_TENANT_MODE
): boolean => mode === 'code'
